var _effectorFileName = "/builds/gmini/front-common/src/classifier-service/ClassifierService/nodePropsUpdate.ts";
import "core-js/modules/es.array.reduce.js";

/* eslint-disable @typescript-eslint/no-explicit-any */
import { nodePropUpdate } from "./nodePropUpdate";
export var nodePropsUpdate = function nodePropsUpdate(props, newObject) {
  return function (oldObject) {
    return oldObject ? props.reduce(function (old, key) {
      var newValue = newObject[key];
      return nodePropUpdate(old, key, newValue);
    }, oldObject) : newObject;
  };
};